import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { FormattedDate } from 'react-intl';

import { ListItem } from 'material-ui/List';
import ActivityIcon from 'material-ui/svg-icons/action/timeline';
import ContextIconMenu from '../Common/ContextIconMenu';
// material-ui 0.14 does not expose the colours yet:
import * as Colors from 'material-ui/styles/colors';

const { red900, green500 } = Colors;

const style = {
    listItem: {
        padding: '2px',
        borderBottom: 'solid 1px #E0E0E0'
    },
    icon: {
        height: '36px',
        width: '36px',
        position: 'absolute',
        top: '0',
        left: '0',
    },
};

const getName = (names)  => {
    return names['en-US'] || names['und'] || names[ Object.keys(names)[0] ] || '';
};

const getActions = (actions) => [

];

const StatementListItem = ({statement, actions}) => {

    // set up a statement object
    const row = {
        id: statement.id,
        timestamp: statement.timestamp,
        actor: {
            name: statement.actor.name,
            type: statement.actor.objectType,
            account: {
                name : statement.actor.account ? statement.actor.account.name : statement.actor.name
            }
        },
        verb: {
            name: statement.verb.id.split('/').pop()
        },
        object: {
            id: '',
            type: '',
            name: 'unknown',
            description: '',
        },
        result: {
            success: '',
            score: undefined
        }
    };

    let activityType = 'Activity';

    if (statement.target) {
        if (statement.target.definition)  {

            if (statement.target.definition.name) {
                row.object.name = getName(statement.target.definition.name);
            }
            if (statement.target.definition.description) {
                row.object.description = getName(statement.target.definition.description);
            }
            if (statement.target.definition.type) {
                activityType = statement.target.definition.type.split('/').pop();
            }

        }
        row.object.id = statement.target.id;
        row.object.type = statement.target.objectType;
    }

    if (!!statement.result) {
        row.result.score = Math.round(statement.result.score.scaled * 100);
    }

    // no more references to props after this line

    const infoLink = `/dashboard/statement/${row.id}`;
    let statusLine;


    let iconProps = {
        style: style.icon,
        color: '#E0E0E0'
    };


    switch (row.verb.name) {

        case 'abandoned':
        case 'answered':
        case 'asked':
        case 'attempted':
        case 'attended':
        case 'commented':
        case 'exited':
        case 'experienced':
        case 'imported':
        case 'initialized':
        case 'interacted':
        case 'logged-in':
        case 'logged-out':
        case 'mastered':
        case 'preferred':
        case 'progressed':
        case 'registered':
        case 'responded':
        case 'resumed':
        case 'satisfied':
        case 'scored':
        case 'shared':
        case 'suspended':
        case 'terminated':
        case 'voided':
        case 'waived':
            statusLine = (`${row.verb.name} `);
            break;

        case 'failed':
            iconProps.color = red900;
            if (row.result.score !== undefined) {
                statusLine = (<span><strong>failed</strong> with score of <strong>{row.result.score}%</strong></span>);
            }
            break;

        case 'completed':
            iconProps.color = 'rgb(35, 151, 190)';
            if (row.result.score !== undefined) {
                statusLine = (<span><strong>completed</strong> with score of <strong>{row.result.score}%</strong></span>);
            }
            break;

        case 'passed':
            iconProps.color = green500;
            if (row.result.score !== undefined) {
                statusLine = (<span><strong>passed</strong> with score of <strong>{row.result.score}%</strong></span>);
            }
            break;

        default:
            break;
    }

    let avatarIcon = (<ActivityIcon {...iconProps}/>);

    switch (activityType) {

        case 'assessment':
        case 'attempt':
        case 'course':
        case 'file':
        case 'interaction':
        case 'lesson':
        case 'link':
        case 'media':
        case 'meeting':
        case 'module':
        case 'objective':
        case 'performance':
        case 'profile':
        case 'question':
        case 'simulation':

            break;

        default:
            break;
    }

    const listItemProps = {
        key: row.id,
        style: style.listItem,
        leftAvatar: (<Link to={infoLink}>{avatarIcon}</Link>),
        primaryText: (<Link to={infoLink} className="primaryText">{row.object.name}</Link>),
        secondaryTextLines: 2
    };

    listItemProps.secondaryText = (
        <Link to={infoLink} className="secondaryText">
            <FormattedDate
                value={row.timestamp}
                day='numeric'
                weekday='short'
                year='numeric'
                month='long'/><br />
            <em>{row.actor.name} {statusLine}</em>
        </Link>
    );

    listItemProps.rightIcon = (
        <ContextIconMenu
            actions={actions || getActions(row)}
            data={row}
        />
    );

    return (

            <ListItem {...listItemProps} />

    );
};

StatementListItem.propTypes = {
    statement: PropTypes.object,
    actions: PropTypes.array
};

export default StatementListItem;
